window.LBSApp = window.LBSApp || {};
window.LBSApp.EventBus = window.LBSApp.EventBus || (function () {
    const eventTarget = new EventTarget();
    const eventBus = {
        events: {},
        debugEnabled: false
    };

    eventBus.setDebugEnabled = function setDebugEnabled(enabled) {
        eventBus.debugEnabled = Boolean(enabled);
    };

    eventBus.isDebugEnabled = function isDebugEnabled() {
        return eventBus.debugEnabled;
    };

    function logEventBus(action, payload) {
        if (!eventBus.debugEnabled) {
            return;
        }

        console.info("[LBSApp.EventBus]", action, payload);
    }

    function publish(name, detail) {
        if (name === undefined || typeof name !== "string") {
            throw new Error("Event name must be a non-empty string");
        }
        logEventBus("publish", { name, detail });
        eventTarget.dispatchEvent(new CustomEvent(name, { detail }));
    }

    function subscribe(name, listener, options) {
        if (name === undefined || typeof name !== "string") {
            throw new Error("Event name must be a non-empty string");
        }
        logEventBus("subscribe", { name, options: options || null });
        eventTarget.addEventListener(name, listener, options);

        return function () {
            logEventBus("unsubscribe", { name, options: options || null });
            eventTarget.removeEventListener(name, listener, options);
        };
    }

    function unsubscribe(name, listener, options) {
        logEventBus("unsubscribe", { name, options: options || null });
        eventTarget.removeEventListener(name, listener, options);
    }

    eventBus.publish = publish;
    eventBus.subscribe = subscribe;
    eventBus.unsubscribe = unsubscribe;
    eventBus.once = function once(name, listener) {
        return subscribe(name, listener, { once: true });
    };

    return eventBus;
})();
